import { makeStyles, tokens } from "@fluentui/react-components";

export const usePlaybookEditorStyles = makeStyles({
  container: {
    marginTop: "1.5rem",
  },
  playbookCard: {
    gap: 0,
    marginTop: "1rem",
    padding: "1.5rem",
    backgroundColor: tokens.colorNeutralBackground2Selected,
  },
  switchRow: {
    marginTop: "1rem",
  },
  playbookRulesCard: {
    gap: 0,
    display: "block",
    marginTop: "0.5rem",
    padding: "1.5rem",
    backgroundColor: tokens.colorNeutralBackground2Selected,
  },
  playbookRulesList: {
    padding: "0",
    listStyle: "none",
    marginTop: "0.5rem",
    marginBottom: "1rem",
  },
  playbookRuleRow: {
    padding: "0.375rem 0",
  },
  playbookRuleRowBordered: {
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
});
